<app-search-dossier (onKeyUp)="onKey($event)"></app-search-dossier>

<div class="tiles" [ngClass]="returnClassName()">
	<ng-container *ngIf="user.hasFullAccess && showIntake">
		<a routerLink="/inspection/list" class="tile tile-short-intake">
			<img src="assets/images/car_schouwing.png">
			<p>Verkorte intake</p>
		</a>
	</ng-container>
	
	<ng-container *ngIf="(user.hasFullAccess || user.hasLoketAccess) && showIntake">
		<a routerLink="/dossier/create" class="tile tile-intake">
			<img src="assets/images/intake_icon.png">
			<p>Intake</p>
		</a>
	</ng-container>

	<ng-container *ngIf="user.hasFullAccess">
		<a  routerLink="/collect" class="tile tile-schouwing">
			<img src="assets/images/inname_logo.png">
			<p>Inname/Schouwing</p>
		</a>
	</ng-container>

	<ng-container *ngIf="user.hasFullAccess || user.hasWorkshopAccess">
		<a routerLink="/dossier/list" class="tile tile-files">
			<img src="assets/images/dossiers_icon.png">
			<p>Dossiers</p>
		</a>
	</ng-container>
	
	<ng-container *ngIf="user.hasFullAccess || user.hasWorkshopAccess">
		<a routerLink="portomechanic/dossiers" class="tile tile-portomechanic">
			<img src="assets/images/portomechanic_icon.png">
			<p>Portomechanic</p>
		</a>
	</ng-container>
</div>